/**
 * Newsletter Popup Modal
 * Handles newsletter popup open/close functionality
 */

(function () {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewsletterPopup);
  } else {
    initNewsletterPopup();
  }

  function initNewsletterPopup() {
    const popups = document.querySelectorAll('.newsletter-popup');
    
    popups.forEach(function(popup) {
      // Find all open buttons globally since popup is now in footer (globally available)
      const openButtons = document.querySelectorAll('.js-newsletter-popup-open');
      const closeButtons = popup.querySelectorAll('.js-newsletter-popup-close');
      const overlay = popup.querySelector('.js-newsletter-popup-overlay');
      const body = document.body;

      if (!popup) {
        return;
      }

      // Initialize focus trap for newsletter popup
      var focusTrap = window.BellavoraFocusTrap && window.BellavoraFocusTrap.initFocusTrap
        ? window.BellavoraFocusTrap.initFocusTrap(popup)
        : null;

      // Store reference to trigger button for focus return
      var storedTriggerButton = null;

      // Open popup
      function openPopup(triggerButton) {
        // Store the trigger button for focus return
        storedTriggerButton = triggerButton;

        popup.setAttribute('aria-hidden', 'false');
        body.style.overflow = 'hidden'; // Prevent body scroll when popup is open
        
        // Update aria-expanded on trigger button
        if (triggerButton) {
          triggerButton.setAttribute('aria-expanded', 'true');
        }

        // Activate focus trap first
        if (focusTrap) {
          focusTrap.activate();
        }

        // Focus management - move focus to first focusable element
        // Use a small delay to ensure the element is visible and focusable
        setTimeout(function() {
          if (window.BellavoraFocusTrap && window.BellavoraFocusTrap.getFocusableElements) {
            var focusables = window.BellavoraFocusTrap.getFocusableElements(popup);
            var firstElement = focusables.first;
            if (firstElement) {
              firstElement.focus();
            } else {
              // Fallback to close button if no focusable elements found
              const firstCloseBtn = popup.querySelector('.js-newsletter-popup-close');
              if (firstCloseBtn) {
                firstCloseBtn.focus();
              }
            }
          } else {
            // Fallback to close button if focus trap utility not available
            const firstCloseBtn = popup.querySelector('.js-newsletter-popup-close');
            if (firstCloseBtn) {
              firstCloseBtn.focus();
            }
          }
        }, 0);
      }

      // Close popup
      function closePopup() {
        popup.setAttribute('aria-hidden', 'true');
        body.style.overflow = ''; // Restore body scroll
        
        // Update aria-expanded on all open buttons
        openButtons.forEach(function (button) {
          button.setAttribute('aria-expanded', 'false');
        });

        // Deactivate focus trap
        if (focusTrap) {
          focusTrap.deactivate();
        }

        // Return focus to the trigger button that opened the popup
        if (storedTriggerButton) {
          setTimeout(function() {
            storedTriggerButton.focus();
            storedTriggerButton = null; // Clear stored reference
          }, 0);
        }
      }

      // Event listeners for open buttons
      openButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          openPopup(button);
        });
      });

      // Event listeners for close buttons
      closeButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          closePopup();
        });
      });

      // Close on overlay click
      if (overlay) {
        overlay.addEventListener('click', function (e) {
          if (e.target === overlay) {
            closePopup();
          }
        });
      }

      // Close on Escape key
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
          closePopup();
        }
      });
    });

    // Re-initialize on section reload (Theme Editor support)
    document.addEventListener('shopify:section:load', function (event) {
      if (event.detail.sectionId && document.querySelector('.newsletter-popup')) {
        // Re-initialize if this section was reloaded
        initNewsletterPopup();
      }
    });
  }
})();
